export const SOCKET_MESSAGE_TYPES = {
  WS_GQL_CLIENT_SUBSCRIBE: 'ws-gql-client-subscribe',
  WS_GQL_CLIENT_RECEIVE: 'ws-gql-client-receive',
  WS_GQL_SCHEMA_VERSION: 'ws-gql-schema-version',
  BROKER_TOPIC: 'gql-live-update',
}

export type SocketData = Record<string, unknown>

export type ListenerFunc = (data?: SocketData) => void
